import {
  DialogActionsProps,
  DialogContentProps,
  DialogTitleProps,
  IconButtonProps,
  ModalProps,
  PaperProps,
  SvgIconProps,
  SxProps,
} from "@mui/material";
import { Theme } from "@mui/system";
import React, { ReactNode } from "react";
import { z } from "zod";
import { AppConstant } from "@/const";
import { PermissionKeyEnum } from "@/const/data.const";
// import { BooleanTypeEnum } from "@/const/app.const";

export interface IProps {
  children?: ReactNode;
  className?: string;
  classes?: object;
}

export interface IIconProps extends SvgIconProps {
  sx?: object;
  className?: string;
}

export interface IStyleProps {
  [x: string]: SxProps<Theme>;
}

export interface ThemeProps extends Theme {
  typography?: {
    h1?: object;
    h2?: object;
    h3?: object;
    h4?: object;
    h5?: object;
    h6?: object;
    body1?: object;
    body2?: object;
    subtitle1?: object;
    subtitle2?: object;
    caption?: object;
  };
}

export interface EventInputFileProps {
  target: HTMLInputElement & EventTarget;
}

export interface ObjectMultiLanguageProps {
  [x: string]: string;
}

export type AppSelectProps = {
  value: string;
  label: ReactNode;
};

export interface KeyAbleProps {
  [key: string]: unknown;
}

export interface DataListPayload {
  doetCode: string;
  divisionCode?: string;
  schoolCode?: string;
  searchKey?: string;
  take?: number;
  skip?: number;
}

export interface IDataResponseModel<T> {
  payload: {
    data: T;
    message: string;
    code?: ApiResponseCodeEnum;
    errorCode?: number;
    stack?: string | null;
    errors?: unknown;
  };
  status: number;
}
export enum ApiResponseCodeEnum {
  Error = "-1",
  NotHandle = "0",
  Success = "1",
}
export interface IDataPagingItemModel<T> {
  data: T[];
  totalCount: number;
}
export interface IDataPagingItemObjectModel<T> {
  data: T;
  totalCount: number;
}
export interface IDataPagingResponseModel<T> extends IDataResponseModel<
  IDataPagingItemModel<T>
> {}
export interface IDataPagingResponseObjectModel<T> extends IDataResponseModel<
  IDataPagingItemObjectModel<T>
> {}

const PagingRequestSchema = z.object({
  skip: z.number().int().nonnegative(),
  take: z.number().int().positive(),
});

const applyPagingRefinement = (shape: z.ZodRawShape) => {
  return PagingRequestSchema.extend(shape).refine(
    (data) => {
      console.log("refine");
      const isValid = AppConstant.PAGE_SIZE_OPTIONS.includes(data.take);
      console.log(isValid);
      return isValid;
    },
    {
      message: "Invalid 'take' value. Must be one of the allowed options.",
      path: ["take"],
    },
  );
};

export { applyPagingRefinement, PagingRequestSchema };

export type IPagingRequestModel = z.infer<typeof PagingRequestSchema>;
export interface IMenuItemModel {
  name: React.ReactElement | string;
  url: string;
  icon?: React.ReactElement;
  iconPath?: string;
  isActive: boolean;
  isCollapse?: boolean;
  permission?: PermissionKeyEnum;
  children?: IMenuItemModel[];
}
export interface IPagingLoadMoreRequestModel {
  lastId: string;
  top: number;
}
export interface ILoadMoreResponseModel<T> {
  data: T[];
  lastId: string;
}
export enum TypeViewEnum {
  Grid,
  Table,
}
export enum SizeModalEnum {
  Sm,
  Md,
  Lg,
  Xl,
  Full,
}

export type AppModalProps = Pick<ModalProps, "onSubmit" | "component"> & {
  closeWhenClickBackdrop?: boolean;
  fullScreen?: boolean;
  isShowCloseIcon?: boolean;
  header?: React.ReactNode | string;
  content?: React.ReactNode;
  footer?: React.ReactNode;
  modalHeaderProps?: DialogTitleProps & {};
  modalContentProps?: DialogContentProps;
  modalFooterProps?: DialogActionsProps & {};
  closeIconProps?: IconButtonProps & {
    customIcon?: ReactNode;
  };
  onClose: () => void;
  size?: SizeModalEnum;
  fullHeight?: boolean;
  /**
   * If `true`, the component is shown.
   */
  open: boolean;
  /**
   * The component used to render the body of the dialog.
   * @default Paper
   */
  PaperComponent?: React.JSXElementConstructor<PaperProps>;
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   * @default {}
   */
  PaperProps?: Partial<PaperProps<React.ElementType>>;
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx?: SxProps<Theme>;
};
export type ContentServerProps = {
  id?: string;
  title?: string;
  children: ReactNode;
  type: SnackbarTypeEnum;
};
export interface IUploadFile {
  id: string;
  organizationId: string;
  fileName: string;
  originName: string;
  link: string;
  size: number;
  categoryType: CategoryTypeUploadEnum;
  ownerId: string;
  type: string;

  // createdBy: number;
  // updatedBy: number;
  // createdAt: string;
  // updatedAt: string;
}
export enum CategoryTypeUploadEnum {
  Test = "test",
  Courses = "Courses",
  CourseDetails = "CourseDetails",
  CourseAttachments = "CourseAttachments",
  InteractiveClassrooms = "InteractiveClassrooms",
  Organizations = "Organizations",
  StandardQuestion = "StandardQuestion",
  StandardAnswer = "StandardAnswer",
  OfficialExamManage = "OfficialExamManage",
  QuestionBank = "QuestionBank",
}

export enum SnackbarTypeEnum {
  ErrorServer,
  Warning,
  Success,
}

export enum ApproveStatusEnum {
  Cancel,
  Approved,
  Pending,
  Rejected,
}
export enum StatusTypeEnum {
  InActive,
  Active,
}

export enum GenderTypeEnum {
  Girl,
  Boy,
}

export const OPTION_GENDER = [
  {
    value: GenderTypeEnum.Girl,
    label: "Nữ",
  },
  {
    value: GenderTypeEnum.Boy,
    label: "Nam",
  },
];

export interface IBreadcrumbItemModel {
  name: string;
  router: string;
  path: string;
}
// export interface AppOptionType {
//   label: string;
//   value: string | number | null;
// }
export const AppOptionTypeSchema = z.object({
  label: z.union([z.string(), z.unknown()]),
  value: z.union([z.string(), z.number()]),
  disabled: z.boolean().optional(),
});
export type AppOptionType = z.infer<typeof AppOptionTypeSchema>;
export enum StatusUploadEnum {
  None,
  Loading,
  Success,
  Error,
}

export const AttachmentSchema = z.object({
  id: z.number(),
  createdBy: z.number().optional(),
  updatedBy: z.number().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  fileName: z.string(),
  originName: z.string(),
  fileType: z.string(),
  keyUpload: z.string(),
  size: z.number(),
  url: z.string(),
  // isUsing: z.nativeEnum(AppConstant.BooleanTypeEnum).optional(),
  documentId: z.union([z.number(), z.null()]).optional(),
  // status: z.nativeEnum(STATUS_UPLOAD).optional(),
});
export type IAttachment = z.infer<typeof AttachmentSchema>;

export const defaultFileSchema = z.object({
  id: z.union([z.number(), z.string()]),
  name: z.string(),
  url: z.string(),
  type: z.string(),
});
export type IDefaultFile = z.infer<typeof defaultFileSchema>;
export const defaultGalaxySchema = defaultFileSchema.extend({
  isDefault: z.boolean(),
});
export type DefaultModalGalaxyType = z.infer<typeof defaultGalaxySchema>;

export interface IWriteLogObject {
  host: string;
  message: string;
  fullMessage: string;
}
